import React, { useEffect, useState } from "react";
import { Outlet, useNavigate } from "react-router-dom";
import { useAppDispatch } from "../../hooks/hooks";
import { useSelector } from "react-redux";
import { selectCurrent } from "../../redux/settings/selectors";
import useWindowDimensions from "../../hooks/useWindowsDimensions";
import ThemeProvider from "../../hooks/themeProvider";
import _ from "lodash";
import { library } from "../../redux/library/action";
import { countries } from "../../redux/countries/action";
import { states } from "../../redux/states/action";
import { cmsSettings } from "../../redux/cmsSettings/action";
import Settings from "../../components/management/Settings";
import IshipXLogin from "../../pages/auth/ishipx";
import moment from "moment";
import { getGatewayId, getGatewayuri, getHostName, getOrigin } from "../../common/services/common.service";
import { metaTokens } from "../../redux/meta-token/action";

const LxLayout = () => {
    let navigate = useNavigate()
    const dispatch = useAppDispatch()
    const [color, setColor] = useState('universal')
    const [favicon, setFavicon] = useState()
    const [isDeferredApiCallsCompleted, setIsDeferredApiCallsCompleted] = useState<boolean>(false);
    const result = useSelector(selectCurrent)
    const { height, width } = useWindowDimensions();
    const { header, footer, visible, sidebar, theme, favIcon, isGuestTokenReady, isThemeAvailable, tenantId } = result

    const deferredAPICalls = () => {
        if (isGuestTokenReady) {
            dispatch(library.read({ url: `https://api.digiit.${process.env.REACT_APP_API_URL}/api/v4.0/library/query-by-list`, entity: 'library', options: { authorization_required: false } }))
            dispatch(countries.read({ url: `https://api.digiit.${process.env.REACT_APP_API_URL}/api/v2.0/beta/countrys`, entity: 'countries', options: { authorization_required: false } }))
            dispatch(states.read({ url: `https://api.digiit.${process.env.REACT_APP_API_URL}/api/v2.0/beta/stateprovinces`, entity: 'states', options: { authorization_required: false } }))
            dispatch(cmsSettings.list({ url: `https://api.digiit.${process.env.REACT_APP_API_URL}/api/v4.0/settings/cms/query`, entity: 'cmsSettings', jsonData: {}, options: { authorization_required: false } }))
            setIsDeferredApiCallsCompleted(true); // this assumes the api calls will be successfull. Have to check for errors before preventing reload
        }
    }

    useEffect(() => {
        if (isGuestTokenReady && !isDeferredApiCallsCompleted) {
            deferredAPICalls();
        }
    }, [isGuestTokenReady]);


    useEffect(() => {
        if (!favicon) return;

        let link: HTMLLinkElement | null = document.querySelector("link[rel*='icon']");

        if (!link) {
            link = document.createElement("link");
            link.rel = "icon";
            document.head.appendChild(link);
        }

        link.href = favicon;
    }, [favicon]);

    useEffect(() => {
        setColor(theme)
        setFavicon(favIcon)
    }, [theme]);

    useEffect(() => {
        const loadSequentially = async () => {

            if (!tenantId || tenantId === -1) return;
            try {
                await dispatch(metaTokens.resetAction({ actionType: 'list' }));
                const metaData: any = await dispatch(metaTokens.list({
                    url: `https://identity.digiit.${process.env.REACT_APP_API_URL}/api/v6.0/iam/token-service/meta-token`, entity: 'metaTokens', jsonData: {
                        "Records": [
                            {
                                "Context": {

                                    "domain": "string",
                                    "core_version": "string",
                                    "Gateway_id": getGatewayId(),
                                    "Gateway_uri": getGatewayuri(),
                                    "bap_id": getHostName(),
                                    "bap_uri": getOrigin(),
                                    "bpp_id": "string",
                                    "bpp_uri": "string",
                                    "city": "string",
                                    "country": "string",
                                    "action": "string",
                                    "transaction_id": "string",
                                    "message_id": "string",
                                    "timestamp": moment.utc(),
                                    "ttl": "string",
                                    "Subscription": "Logisitcs",
                                    "Domain": "Logisitcs",
                                    "SubDomains": [
                                        "Delivery"
                                    ],
                                    "Network": "Logistics_Customer",
                                    "Application": "Customer",
                                    "Channel": "CSP"
                                },
                                "Message": {
                                }
                            }
                        ]
                    }
                }))


            } catch (error) {
                console.error('Error during sequential loading', error);

            }
        };

        loadSequentially();

    }, [dispatch, tenantId]);

    return (
        <>
            <ThemeProvider>
                {width && width < 720 ? (
                    //  Start - Mobile View
                    <>

                    </>
                    //  End - Mobile View
                ) : width && width >= 720 && width < 1024 ? (
                    //  Start - Tablet View
                    <>

                    </>
                    //  End - Tablet View
                ) : (
                    //  Start - Web View 
                    <div className="leading-normal tracking-normal bg-primary" id="main-body">
                        <div className=" w-full overflow-auto">
                            {visible && <Settings />}
                            <Outlet />
                        </div>
                    </div>
                    //  End - Web View 
                )}
            </ThemeProvider>
        </>
    )
}
export default LxLayout;